// Explicitly listing the calculations we intend to use because
// we want them ordered in a specific way, and it may be possible in the future
// that we only use a subset of calculations for the legend because the calculations

import { z } from 'zod/v4';

// are also used by other features.
export const aggregationsSchema = z.enum(['Mean', 'First', 'FirstNumber', 'Last', 'LastNumber', 'Min', 'Max', 'Sum']);

export type Aggregations = z.infer<typeof aggregationsSchema>;
